/**
 * custom.js — V1.01 — Membership Offer Update
 * - Added MembershipOffer IIFE: price engine, DOM updaters, discount code apply/remove
 * - Modified membership checkbox handler to call offer engine on toggle
 * - Extended package-radio handler to recalculate prices when offer is active
 */

/* Cart Upcell js */

(function () {

  /* ===============================
     GLOBALS
  =============================== */
  window.upsellSwiper = null;
  let selectedVariantId = null;

  /* ===============================
     INIT SWIPER
  =============================== */
  window.initUpsellSwiper = function () {
    window.upsellSwiper = new Swiper('.cart-upsell-slider', {
      slidesPerView: 1,
      spaceBetween: 12,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        0: { slidesPerView: 1 },
        376: { slidesPerView: 1.3 },
        500: { slidesPerView: 2 },
        1024: { slidesPerView: 2 }
      }
    });
  };

  window.refreshUpsellSwiper = function () {
    setTimeout(window.initUpsellSwiper, 100);
  };

  /* ===============================
     CHECK ALL UPSELLS ADDED
  =============================== */
  function checkIfAllUpsellsAdded() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const wrapper = document.querySelector('.gt-customcart-upsell-wr');
        if (!wrapper) return;

        const cartIds = cart.items.map(i => i.product_id);
        const items = wrapper.querySelectorAll('.upsell-item');
        const allAdded = [...items].every(item =>
          cartIds.includes(+item.dataset.productId)
        );

        wrapper.style.display = allAdded ? 'none' : '';
      })
      .catch(console.error);
  }

  /* ===============================
     PRESERVE FETCH HOOK
  =============================== */
  const originalFetch = window.fetch;
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    if (args[0].includes('/cart/')) {
      response.clone().json()
        .then(() => window.refreshUpsellSwiper())
        .catch(() => window.refreshUpsellSwiper());
    }
    return response;
  };

  /* ===============================
     ADD TO CART BUTTON HANDLER
  =============================== */
  document.addEventListener('click', function (e) {

    if (!e.target.classList.contains('upsell-add-btn')) return;

    e.preventDefault();

    const btn = e.target;
    const card = btn.closest('.upsell-item');
    if (!card || btn.disabled) return;

    const product = JSON.parse(card.dataset.product);
    const hasMultiple = product.variants.length > 1;

    if (hasMultiple) {
      openVariantPopup(product);
      return;
    }

    addToCart(product.variants[0].id, btn);
  });

  /* ===============================
     ADD TO CART
  =============================== */
  function addToCart(variantId, btn = null) {

    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Adding…';
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(res => {
        if (!res.ok) throw new Error('Add to cart failed');
        return fetch(`/cart?sections=cart-drawer`);
      })
      .then(res => res.json())
      .then(sections => {
        const html = new DOMParser().parseFromString(
          sections['cart-drawer'],
          'text/html'
        );

        const newDrawer = html.querySelector('cart-drawer');
        const oldDrawer = document.querySelector('cart-drawer');

        if (oldDrawer && newDrawer) {
          oldDrawer.replaceWith(newDrawer);
        }

        document.body.classList.add('overflow-hidden');

        const themeCart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        if (themeCart) {
          themeCart.classList.add('active');
        }

        window.initUpsellSwiper();
        checkIfAllUpsellsAdded();

        return true; // ✅ SUCCESS FLAG
      });
  }


  /* ===============================
     MODAL HELPERS
  =============================== */
  function openModalLock() {
    document.body.classList.add('upsell-modal-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModalLock() {
    document.body.classList.remove('upsell-modal-open');
    document.body.style.overflow = '';
  }

  /* ===============================
     VARIANT POPUP
  =============================== */
  function openVariantPopup(product) {

    const modal = document.getElementById('upsellVariantModal');
    if (!modal) return;

    const priceEl = document.getElementById('upsellModalPrice');
    const ratingEl = document.getElementById('upsellModalRating');
    const variantTitleEl = document.getElementById('upsellModalVariantTitle');
    const wrap = document.getElementById('upsellModalVariants');

   modal.hidden = false;
modal.classList.remove('is-closing');
modal.classList.add('is-open');
openModalLock();
    openModalLock();

    document.getElementById('upsellModalTitle').textContent = product.title;
    wrap.innerHTML = '';

    let firstAvailableVariant = null;

    product.variants.forEach((variant, index) => {
      if (!variant.available) return;

      const img = variant.featured_image?.src || product.featured_image?.src;
      if (!img) return;

      if (!firstAvailableVariant) firstAvailableVariant = variant;

      wrap.insertAdjacentHTML('beforeend', `
        <div class="upsell-variant-image">
          <img src="${img}" data-variant-id="${variant.id}">
        </div>
      `);
    });

    if (firstAvailableVariant) {
      document.getElementById('upsellModalImage').src =
        firstAvailableVariant.featured_image?.src || product.featured_image?.src;
      selectedVariantId = firstAvailableVariant.id;
      updateVariantUI(firstAvailableVariant);
    }

    function formatPrice(p) {
      return `$${(Number(p) / 100).toFixed(2)}`;
    }

    function updateVariantUI(variant) {
      priceEl.textContent = formatPrice(variant.price);
      ratingEl.textContent = variant.rating ? '⭐'.repeat(Math.round(variant.rating)) : '';

      if (variant.options && product.options) {
        variantTitleEl.textContent = variant.options
          .map((v, i) => `${product.options[i]}: ${v}`)
          .join(' | ');
      }
    }

    wrap.querySelectorAll('img').forEach(img => {
      img.addEventListener('click', function () {
        selectedVariantId = this.dataset.variantId;
        document.getElementById('upsellModalImage').src = this.src;

        wrap.querySelectorAll('.upsell-variant-image')
          .forEach(el => el.classList.remove('selected'));

        this.parentElement.classList.add('selected');

        const v = product.variants.find(v => v.id == selectedVariantId);
        if (v) updateVariantUI(v);
      });
    });
  }

  /* ===============================
     POPUP EVENTS
  =============================== */
  document.addEventListener('click', e => {

    if (e.target.id === 'upsellModalAddBtn') {
      if (!selectedVariantId) return alert('Select a variant');

      const btn = e.target;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      addToCart(selectedVariantId, btn)
        .then(() => {
          closeUpsellModal(); // ✅ cart me add hone ke baad hi close
        })
        .catch(() => {
          btn.disabled = false;
          btn.textContent = 'Add';
          alert('Something went wrong. Please try again.');
        });
    }


    if (
  e.target.classList.contains('upsell-modal-close') ||
  (e.target.id === 'upsellVariantModal' && !e.target.closest('.upsell-modal-box'))
) {
  closeUpsellModal();
}

  });

 function closeUpsellModal() {
    const modal = document.getElementById('upsellVariantModal');
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.classList.add('is-closing');

    setTimeout(() => {
      modal.classList.remove('is-closing');
      modal.hidden = true;
      closeModalLock();
    }, 300);
  }

  /* ===============================
     INIT
  =============================== */
  document.addEventListener('DOMContentLoaded', () => {
    window.initUpsellSwiper();
    checkIfAllUpsellsAdded();
  });

})();



/*End Cart Upcell js */



// -----------------logos-slider---------------------- //
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof jQuery !== 'undefined' && jQuery('.aso-bxslider').length) {
      jQuery('.aso-bxslider').bxSlider({
        minSlides: 4,
        maxSlides: 4,
        moveSlides: 1,
        slideWidth: 200,
        slideMargin: 10,
        ticker: true,
        speed: 15000,
        adaptiveHeight: false,
        pager: false,
        controls: false
      });
    }
  });

// -----------------logos-slider---------------------- //

jQuery(function ($) {

  const $items = $('.faq-item');
  const $videos = $('.faq-media-item');

  // Open first FAQ (only if exists)
  if ($items.length) {
    openFaq($items.first(), 0);
  }

  $('.faq-question-blk').on('click', function () {
    const $item = $(this).closest('.faq-item');
    const index = $(this).data('index');

    if ($item.hasClass('active')) {
      closeFaq($item);
    } else {
      openFaq($item, index);
    }
  });

  function openFaq($item, index) {

    // Close all
    $items.removeClass('active')
      .find('.faq-answer-blk')
      .css('height', 0);

    $('.faq-icon').each(function () {
      $(this).attr(
        'src',
        $(this).closest('.faq-question-blk').data('plus')
      );
    });

    // Open current
    $item.addClass('active');

    const $answer = $item.find('.faq-answer-blk');

    // ✅ SAFETY CHECK
    if ($answer.length) {
      $answer.css('height', $answer[0].scrollHeight + 'px');
    }

    $item.find('.faq-icon')
      .attr(
        'src',
        $item.find('.faq-question-blk').data('minus')
      );

    // Video swap
    const $activeVideo = $videos
      .removeClass('active')
      .filter(`[data-faq-index="${index}"]`)
      .addClass('active')
      .find('video')
      .get(0);

      if ($activeVideo) {
        $activeVideo.currentTime = 0;
        $activeVideo.play();
    }
  }

  function closeFaq($item) {
    $item.removeClass('active')
      .find('.faq-answer-blk')
      .css('height', 0);

    $item.find('.faq-icon')
      .attr(
        'src',
        $item.find('.faq-question-blk').data('plus')
      );
  }
});


$(document).ready(function ($) {

  /* ======================
     DESKTOP TABS
  ====================== */
  $('.desktop-tabs').each(function () {

    var $section = $(this);

    function activateTab(tabId, tabText) {

      $section.find('.tab-btn').removeClass('active');
      $section.find('.tab-image').removeClass('active');

      $section.find('.tab-btn[data-tab="' + tabId + '"]').addClass('active');
      $section.find('.tab-image[data-tab="' + tabId + '"]').addClass('active');

      if (tabText) {
        $section.find('.tabs-text').text(tabText);
      }
    }

    $section.find('.tab-btn').on('click', function () {
      activateTab($(this).data('tab'), $(this).data('text'));
    });

    $section.find('.tab-image').on('click', function () {
      activateTab($(this).data('tab'), $(this).data('text'));
    });

  });


  /* ======================
     MOBILE ACCORDION
  ====================== */

  $('.mobile-accordion .accordion-content').each(function () {
    if (!$(this).hasClass('active')) {
      $(this).hide(); // only once on load
    }
  });

  $('.mobile-accordion .accordion-header').on('click', function () {

    var $currentItem = $(this).closest('.accordion-item');
    var $currentContent = $currentItem.find('.accordion-content');

    // CLOSE others
    $('.mobile-accordion .accordion-header').not(this).removeClass('active');
    $('.mobile-accordion .accordion-content').not($currentContent).stop(true, true).slideUp(300).removeClass('active');

    // TOGGLE current
    $(this).toggleClass('active');
    $currentContent.stop(true, true).slideToggle(300).toggleClass('active');

  });



});


// Tabber Faq
document.addEventListener('DOMContentLoaded', function () {

    const firstTabBtn = document.querySelector('.faq-tab-btn');
  const firstTabContent = document.querySelector('.faq-tab-content');

  if (firstTabBtn && firstTabContent) {
    firstTabBtn.classList.add('active');
    firstTabContent.classList.add('active');
  }


    const faqTabs = document.querySelector('.faq-tabs');
  if (faqTabs) {
    const offsetTop = faqTabs.offsetTop;

      window.addEventListener('scroll', () => {
      if (window.scrollY > offsetTop) {
        faqTabs.classList.add('is-sticky');
      } else {
        faqTabs.classList.remove('is-sticky');
      }
      });
  }


  const sections = document.querySelectorAll('.tabbed-faq');
  if (!sections.length) return;


  function slideDown(el) {
    el.style.display = 'block';
    el.style.height = 'auto';

    const height = el.scrollHeight + 'px';
    el.style.height = '0px';
    el.offsetHeight;

    el.style.transition = 'height 0.35s ease';
    el.style.height = height;

    el.addEventListener('transitionend', function handler() {
      el.style.height = 'auto';
      el.removeEventListener('transitionend', handler);
    });
  }


  function slideUp(el) {
    el.style.height = el.scrollHeight + 'px';
    el.offsetHeight;
    el.style.transition = 'height 0.35s ease';
    el.style.height = '0px';

    el.addEventListener('transitionend', function handler() {
      el.style.display = 'none';
      el.removeEventListener('transitionend', handler);
    });
  }



  sections.forEach(section => {
    section.querySelectorAll('.faq-tab-content').forEach(tab => {

      const items = tab.querySelectorAll('.tabber-faq-item');
      if (!items.length) return;

      items.forEach(item => {
        const ans = item.querySelector('.tabber-faq-answer');
        ans.style.height = '0px';
      });

      // const first = items[0];
      // first.classList.add('active');
      // slideDown(first.querySelector('.tabber-faq-answer'));
    });

    section.querySelectorAll('.tabber-faq-item').forEach(item => {

      const question = item.querySelector('.tabber-faq-question');
      const answer  = item.querySelector('.tabber-faq-answer');

      if (!question || !answer) return;

      question.addEventListener('click', function () {

        const tab = item.closest('.faq-tab-content');
        const itemsInTab = tab.querySelectorAll('.tabber-faq-item');

        if (item.classList.contains('active')) {
          item.classList.remove('active');
          slideUp(answer);
          return;
        }

        itemsInTab.forEach(i => {
          if (i !== item && i.classList.contains('active')) {
            i.classList.remove('active');
            slideUp(i.querySelector('.tabber-faq-answer'));
          }
        });

        item.classList.add('active');
        slideDown(answer);

        item.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      });

    });

    section.querySelectorAll('.faq-tab-btn').forEach(btn => {

      btn.addEventListener('click', function () {

        section.querySelectorAll('.faq-tab-btn')
          .forEach(b => b.classList.remove('active'));

        section.querySelectorAll('.faq-tab-content')
          .forEach(c => c.classList.remove('active'));

        this.classList.add('active');

        const target = section.querySelector('#' + this.dataset.tab);
        if (!target) return;

        target.classList.add('active');

        const offset = 300;
        const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      });

    });
  });
});


$(document).ready(function () {
  var $header = $('.header-wrapper');
  var $megaMenu = $('.mega-menu-section');
  var $menuTrigger = $('#HeaderMenu-shop');

  $megaMenu.hide();

  if ($header.length && $megaMenu.length) {
    $header.append($megaMenu);
  }

  var hoverTimeout;

  $menuTrigger.add($megaMenu).hover(
    function () {
      clearTimeout(hoverTimeout);
      hoverTimeout = setTimeout(function () {
        $megaMenu.stop(true, true).fadeIn(200).addClass('active');
        $menuTrigger.addClass('active');
      }, 100);
    },
    function () {
      clearTimeout(hoverTimeout);
      hoverTimeout = setTimeout(function () {
        $megaMenu.stop(true, true).fadeOut(200, function () {
          $(this).removeClass('active');
        });
        $menuTrigger.removeClass('active');
      }, 200);
    }
  );
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.color-swatches .color-swatch').forEach(function (swatch) {
    swatch.addEventListener('click', function (e) {
      e.preventDefault();
      let newImage = this.getAttribute('data-image');
      let productCard = this.closest('.card');
      let mainImage = productCard.querySelector('.card__media img');

      if (mainImage) {
        mainImage.src = newImage;
        mainImage.srcset = newImage;
      }
    });
  });
});

/* ===============================
   V1.01 — MEMBERSHIP OFFER ENGINE
   Calculates offer prices and updates DOM in 3 locations:
   1) Top price under product name
   2) Package selector cards
   3) ATC button
   Also applies/removes discount code via /cart/update.js
=============================== */
var MembershipOffer = (function ($) {
  'use strict';

  /* --- Config (read from data attributes on .membership-wr) --- */
  var cfg = { enabled: false, discountCode: '', discountAmountCents: 0 };

  /* --- State flags --- */
  var _active = false;          // Is offer currently applied to DOM?
  var _updating = false;        // Guard to prevent MutationObserver loops
  var _observer = null;         // MutationObserver reference
  var _debounceTimer = null;    // Debounce timer for observer

  function init() {
    var $wr = $('.membership-wr');
    if (!$wr.length || $wr.data('offer-enabled') !== true) return;

    cfg.enabled = true;
    cfg.discountCode = ($wr.data('offer-discount-code') || '').toString();
    cfg.discountAmountCents = parseInt($wr.data('offer-discount-amount'), 10) || 2900;

    /* Start MutationObserver to persist prices across Shopify section re-renders */
    startObserver();
  }

  function isEnabled() { return cfg.enabled; }

  /* --- Money formatter (cents → $X.XX) --- */
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* --- Get active variant data from selected package card --- */
  function getActiveVariant() {
    var $checked = $('.package-radio:checked');
    if (!$checked.length) return null;

    /* Radio is a sibling of the label, not inside it — use for= attribute */
    var $card = $('label.package-card[for="' + $checked.attr('id') + '"]');
    if (!$card.length) return null;

    var price = parseInt($card.data('variant-price'), 10) || 0;
    var compare = parseInt($card.data('variant-compare'), 10) || 0;
    return { price: price, compare: compare };
  }

  /* --- LOCATION 1: Top price under product name --- */
  function updateTopPrice(on) {
    var $priceContainer = $('.price--on-product');
    if (!$priceContainer.length) $priceContainer = $('.price').first();

    /* Shopify has TWO sub-sections inside .price:
       .price__regular  — visible when NOT on sale (hidden when on sale)
       .price__sale     — visible when on sale (hidden when not)
       We must target the .price__sale sub-section so our changes are visible. */
    var $saleSection = $priceContainer.find('.price__sale');
    var $regular, $sale;

    if ($saleSection.length) {
      $regular = $saleSection.find('.price-item--regular').first();
      $sale    = $saleSection.find('.price-item--sale').first();
    } else {
      $regular = $priceContainer.find('.price-item--regular').first();
      $sale    = $priceContainer.find('.price-item--sale').first();
    }

    if (!on) {
      /* Restore: let Shopify's default take over */
      $priceContainer.removeClass('price--on-sale');
      $regular.removeAttr('data-offer-active');
      $sale.removeAttr('data-offer-active');
      var v = getActiveVariant();
      if (v) {
        if (v.compare > 0 && v.compare > v.price) {
          $priceContainer.addClass('price--on-sale');
          $regular.html('<s>' + money(v.compare) + '</s>');
          $sale.text(money(v.price));
        } else {
          $regular.text(money(v.price));
          $sale.text('');
        }
      }
      return;
    }

    var v = getActiveVariant();
    if (!v) return;

    /* Offer price = variant price - discount */
    var offerPrice = v.price - cfg.discountAmountCents;
    /* Strikethrough = compare-at if exists, otherwise variant price */
    var strikePrice = (v.compare > 0) ? v.compare : v.price;

    $priceContainer.addClass('price--on-sale');
    $regular.attr('data-offer-active', 'true')
            .html('<s>' + money(strikePrice) + '</s>');
    $sale.attr('data-offer-active', 'true')
         .text(money(offerPrice));
  }

  /* --- LOCATION 2: Package selector cards --- */
  function updatePackageCards(on) {
    var pillLabel = 'CLUB LEAF&nbsp;&nbsp;$' + (cfg.discountAmountCents / 100) + ' OFF';

    $('.package-card').each(function () {
      var $card = $(this);
      var $compare = $card.find('.package-compare');
      var $price = $card.find('.package-price');

      var origPrice = parseInt($card.data('variant-price'), 10) || 0;
      var origCompare = parseInt($card.data('variant-compare'), 10) || 0;

      if (!on) {
        /* Restore original values */
        if (origCompare > 0 && origCompare > origPrice) {
          $compare.html('<s>' + money(origCompare) + '</s>').show();
        } else {
          $compare.html('').hide();
        }
        $price.text(money(origPrice));

        /* Remove Club Leaf pill; tear down .package-top if we created it */
        $card.find('.club-leaf-pill').remove();
        var $top = $card.find('.package-top');
        if ($top.length && $top.children().length === 0) $top.remove();
        return;
      }

      /* --- Pill: inject "CLUB LEAF $29 OFF" coupon tag --- */
      var $top = $card.find('.package-top');
      if (!$top.length) {
        /* Razor has no badge, so .package-top doesn't exist yet — create it */
        $top = $('<div class="package-top"></div>');
        $card.prepend($top);
      }
      if (!$top.find('.club-leaf-pill').length) {
        $top.append('<span class="club-leaf-pill">' + pillLabel + '</span>');
      }

      /* Create .package-compare span if it doesn't exist (e.g. Razor with no compare-at) */
      if (!$compare.length) {
        $compare = $('<span class="package-compare"></span>');
        $card.find('.package-right').prepend($compare);
      }

      /* Offer: strikethrough = compare-at or variant price; display = variant - discount */
      var strike = (origCompare > 0) ? origCompare : origPrice;
      var display = origPrice - cfg.discountAmountCents;

      $compare.html('<s>' + money(strike) + '</s>').show();
      $price.text(money(display));
    });
  }

  /* --- LOCATION 3: ATC button — DISABLED (V1.02) ---
     Button always shows its default "Add to Cart" label.
     Kept as a no-op so callers don't need to change. */
  function updateATCButton(/* on */) { return; }

  /* --- Master toggle: update all 3 locations --- */
  function applyOffer(on) {
    if (!cfg.enabled) return;
    _active = on;
    _updating = true;
    updateTopPrice(on);
    updatePackageCards(on);
    updateATCButton(on);
    /* Release guard after DOM settles (prevents observer re-trigger loop) */
    setTimeout(function () { _updating = false; }, 200);
  }

  /* --- Check if Shopify re-rendered over our offer pricing --- */
  function needsReapply() {
    if (!_active) return false;
    /* Check the VISIBLE price element inside .price__sale (not the hidden .price__regular) */
    var $pc = $('.price--on-product');
    if (!$pc.length) $pc = $('.price').first();
    var $saleSection = $pc.find('.price__sale');
    var $reg = $saleSection.length
      ? $saleSection.find('.price-item--regular').first()
      : $pc.find('.price-item--regular').first();
    if ($reg.length && $reg.attr('data-offer-active') !== 'true') return true;
    return false;
  }

  /* --- MutationObserver: catch Shopify section re-renders and re-apply pricing --- */
  function startObserver() {
    if (_observer || typeof MutationObserver === 'undefined') return;

    /* Find a stable ancestor that survives section re-renders.
       Shopify replaces content INSIDE the section, not the section wrapper itself. */
    var $section = $('.product-form-wr').closest('.shopify-section');
    var target = $section.length ? $section[0]
               : (document.querySelector('main') || document.body);

    _observer = new MutationObserver(function () {
      if (_updating) return;
      clearTimeout(_debounceTimer);
      _debounceTimer = setTimeout(function () {
        if (!_updating && needsReapply()) {
          applyOffer(true);
        }
      }, 60);
    });

    _observer.observe(target, { childList: true, subtree: true });
  }

  /* --- Discount code: apply via /cart/update.js (Shopify Editions '25) --- */
  function applyDiscountCode(callback) {
    if (!cfg.discountCode) { if (callback) callback(); return; }
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: JSON.stringify({ discount: cfg.discountCode }),
      contentType: 'application/json',
      dataType: 'json',
      complete: function () { if (callback) callback(); }
    });
  }

  /* --- Discount code: remove via /cart/update.js with empty string --- */
  function removeDiscountCode(callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: JSON.stringify({ discount: '' }),
      contentType: 'application/json',
      dataType: 'json',
      complete: function () { if (callback) callback(); }
    });
  }

  /* --- Recalc on package change (if membership is checked) --- */
  function recalcIfActive() {
    if (!cfg.enabled) return;
    var isChecked = $('#membership-checkbox').is(':checked');
    if (isChecked) {
      _active = true;
      applyOffer(true);
    }
  }

  /* --- Public API --- */
  return {
    init: init,
    isEnabled: isEnabled,
    applyOffer: applyOffer,
    applyDiscountCode: applyDiscountCode,
    removeDiscountCode: removeDiscountCode,
    recalcIfActive: recalcIfActive
  };

})(jQuery);


/* ===============================
   V1.01 — MEMBERSHIP CHECKBOX HANDLER (modified)
   Original: add/remove membership from cart
   Added: discount code apply/remove + price DOM updates via MembershipOffer
=============================== */
$(document).ready(function () {
  const variantId = parseInt($('#membership-variant-id').val());
  const sellingPlanId = parseInt($('#membership-selling-plan-id').val());

  const $checkbox = $('#membership-checkbox');
  const $card = $('.membership-card');
  const $status = $('.membership-status');

  /* Init offer engine on page load */
  MembershipOffer.init();

  function startLoading() {
    $card.addClass('is-loading');
    $status.css('display', 'flex');
  }

  function stopLoading() {
    $card.removeClass('is-loading');
    $status.hide();
  }

  $checkbox.on('change', function () {

    if ($(this).is(':checked')) {
      startLoading();
      $checkbox.prop('disabled', true);

      /* Update PDP prices immediately (optimistic UI) */
      MembershipOffer.applyOffer(true);

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1,
            selling_plan: sellingPlanId
          }]
        }),
        contentType: 'application/json',
        dataType: 'json',
        success: function () {
          /* Apply discount code after membership is in cart */
          MembershipOffer.applyDiscountCode();
        },
        complete: function () {
          stopLoading();
          $checkbox.prop('disabled', false);
        },
        error: function () {
          $checkbox.prop('checked', false);
          /* Revert prices on failure */
          MembershipOffer.applyOffer(false);
        }
      });

    } else {
      startLoading();
      $checkbox.prop('disabled', true);

      /* Revert PDP prices immediately (optimistic UI) */
      MembershipOffer.applyOffer(false);

      /* Remove discount code first, then remove membership */
      MembershipOffer.removeDiscountCode(function () {
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: {
            id: variantId,
            quantity: 0
          },
          dataType: 'json',
          complete: function () {
            stopLoading();
            $checkbox.prop('disabled', false);
          },
          error: function () {
            $checkbox.prop('checked', true);
            /* Re-apply prices on failure */
            MembershipOffer.applyOffer(true);
            MembershipOffer.applyDiscountCode();
          }
        });
      });
    }
  });

  /* -----------------------------------------------------------------
     V1.02 — RESET MEMBERSHIP AFTER ATC
     Uncheck the membership box and revert offer pricing after
     the product form submits, so the PDP is clean if the user
     comes back to shop again.
  ----------------------------------------------------------------- */
  var $productForm = $('form[action="/cart/add"]');
  if ($productForm.length) {
    $productForm.on('submit', function () {
      if (!$checkbox.is(':checked')) return;
      /* Brief delay so Shopify's handler grabs the current cart state first */
      setTimeout(function () {
        $checkbox.prop('checked', false);
        MembershipOffer.applyOffer(false);
      }, 300);
    });
  }
});

// leaf two razor 
(function ($) {

  const $mainImage = $('#mainImage');
  const variants = window.productVariants || [];

  /* ---------- HELPERS ---------- */
  const clean = src =>
    src ? (src.replace(/&amp;/g, '&').startsWith('//') ? 'https:' + src : src) : '';

  const fadeImage = src => {
    if (!src || !$mainImage.length) return;

    $mainImage
      .css({ transition: 'opacity .2s ease', opacity: 0 })
      .delay(200)
      .queue(function (next) {
        $(this).attr('src', src).one('load', () => $(this).css('opacity', 1));
        next();
      });
  };

  /* ---------- VARIANT IMAGE ---------- */
  $(document).on('change', '.swatch-input__input:checked', function () {
    const selected = $('.product-form__input input[type="radio"]:checked')
      .map((_, el) => el.value).get();

    const variant = variants.find(v =>
      v.options.every((opt, i) => opt === selected[i])
    );

    if (variant?.featured_image?.src) {
      fadeImage(clean(variant.featured_image.src));
    }
  });

  /* ---------- PACKAGE IMAGE (SAME AS COLOR) ---------- */
  /* V1.01 — Added MembershipOffer.recalcIfActive() to update offer prices on package switch */
  $(document).on('change', '.package-radio', function () {

    const selected = $('.product-form__input input[type="radio"]:checked')
      .map((_, el) => el.value)
      .get();

    const variant = variants.find(v =>
      v.options.every((opt, i) => opt === selected[i])
    );

    if (variant?.featured_image?.src) {
      fadeImage(clean(variant.featured_image.src));
    }

    /* Recalculate offer prices if membership is active.
       Staggered delays ensure we fire AFTER Shopify's async section re-render.
       The MutationObserver also catches re-renders, but these are belt-and-suspenders. */
    if (typeof MembershipOffer !== 'undefined') {
      [150, 500, 1000].forEach(function (delay) {
        setTimeout(function () {
          MembershipOffer.recalcIfActive();
        }, delay);
      });
    }
  });


  /* ---------- CUSTOM GALLERY ---------- */
  function initGallery() {
    const $gallery = $('.custom-media-gallery');
    if (!$gallery.length) return;

    const $tabs = $gallery.find('.media-tab');
    const $thumbs = $gallery.find('.media-thumb');

    let $first = $thumbs.show().first();
    if ($first.length) fadeImage($first.find('img').data('full'));

    $thumbs.off('click').on('click', function () {
      fadeImage($(this).find('img').data('full'));
    });

    $tabs.off('click').on('click', function () {
      const type = $(this).data('tab');
      $tabs.removeClass('is-active');
      $(this).addClass('is-active');

      const $visible = $thumbs.hide().filter(function () {
        return ($(this).data('category') || '').includes(type);
      }).show().first();

      if ($visible.length) {
        fadeImage($visible.find('img').data('full'));
      }
    });
  }

  /* ---------- INIT ---------- */
  $(window).on('load', initGallery);
  $(document).on('variant:change shopify:section:load', () => setTimeout(initGallery, 100));

})(jQuery);


// new Swiper('.media-thumb-swiper', {
//   slidesPerView: 4,
//   spaceBetween: 10,
//   watchSlidesProgress: true,
//   loop: true,
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev'
//   },
//   breakpoints: {
//     0: { slidesPerView: 3 },
//     768: { slidesPerView: 6 }
//   }
// });



// Media Thub Product
const thumbSwiper = new Swiper('.media-thumb-swiper', {
  slidesPerView: 4,
  spaceBetween: 10,
  watchSlidesProgress: true,
  loop: false,
  navigation: {
    nextEl: '.media-swiper-button-next',
    prevEl: '.media-swiper-button-prev'
  },
  breakpoints: {
    0: { slidesPerView: 3 },
    768: { slidesPerView: 4 }
  }
});

document.querySelectorAll('.media-tab').forEach(tab => {
  tab.addEventListener('click', function () {
    const selected = this.dataset.tab;

    document
      .querySelectorAll('.media-tab')
      .forEach(t => t.classList.remove('is-active'));
    this.classList.add('is-active');

    document
      .querySelectorAll('.media-thumb-swiper .swiper-slide')
      .forEach(slide => {
        const categories = slide.dataset.category || '';
        slide.style.display = categories.includes(selected)
          ? ''
          : 'none';
      });

    thumbSwiper.slideTo(0, 0);  
    thumbSwiper.update();      
  });
});





// leaf two razor 

  new Swiper('.testimonial-swiper', {
    loop: true,
    slidesPerView: 1.2, // Number of testimonials visible at a time
    spaceBetween: 33, // Gap between slides
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      568: {
        slidesPerView: 2,
        autoplay: false,
      },
      1024: {
        slidesPerView: 3,
      }
    }
  });

  // Listen for changes on color swatches
$('.featured-products').on(
  'change',
  '.variant-color-options input[type="radio"]',
  function () {
    var $radio = $(this);
    var $productCard = $radio.closest('.product-card');
    var $image = $productCard.find('.product-main-image');
    var $json = $productCard.find('.product-variants-json');
    var $colorName = $productCard.find('.selected-color-name');

    if (!$image.length || !$json.length) return;

    var variants = JSON.parse($json.text());
    var selectedColor = $radio.val();

    // Update color name
    if ($colorName.length) {
      $colorName.text(selectedColor);
    }

    // Smooth fade image swap
    if (variants[selectedColor] && variants[selectedColor].image) {
      var newSrc = variants[selectedColor].image;

      if ($image.attr('src') === newSrc) return;

      $image.addClass('is-fading');

      setTimeout(function () {
        $image.attr('src', newSrc);

        // Ensure image is loaded before fade-in
        $image.one('load', function () {
          $image.removeClass('is-fading');
        });
      }, 200);
    }
  }
);


$(document).on('change', '.card-wrapper .variant-option-input', function() {
  var $input = $(this);
  var $cardWrapper = $input.closest('.card-wrapper');

  if (!$cardWrapper.length) return;

  var $mainImg = $cardWrapper.find('.main-product-image');
  var newImgSrc = $input.data('main');
  if ($mainImg.length && newImgSrc) {
    $mainImg.attr('src', newImgSrc).attr('srcset', '');
  }

  var $variantField = $cardWrapper.find('form input[name="id"]');
  if ($variantField.length) $variantField.val($input.val());

  var $colorNameSpan = $cardWrapper.find('.selected-color-name');
  if ($colorNameSpan.length) $colorNameSpan.text($input.data('color'));
});




// Hover Effect Submenu
document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth < 990) return;

  const details = document.getElementById('Details-HeaderMenu-2');
  const summary = document.getElementById('HeaderMenu-learn');

  if (!details || !summary) return;

  /* CLICK disable */
  summary.addEventListener('click', (e) => {
    e.preventDefault();
  });

  /* HOVER open */
  details.addEventListener('mouseenter', () => {
    details.setAttribute('open', '');
    summary.setAttribute('aria-expanded', 'true');
  });

  details.addEventListener('mouseleave', () => {
    details.removeAttribute('open');
    summary.setAttribute('aria-expanded', 'false');
  });
});


// --product single-faq
$(document).ready(function ($) {
  const $items = $('.faq-item');

  // ensure all answers are closed on load
  $items.each(function () {
    $(this).find('.faq-answer').css('height', '0px');
    $(this).removeClass('active');
  });

  function closeItem($item) {
    const $answer = $item.find('.faq-answer');
    const $icon = $item.find('.faq-icon img');

    // from auto to px for smooth close
    if ($answer.css('height') === 'auto') {
      $answer.css('height', $answer[0].scrollHeight + 'px');
    }

    requestAnimationFrame(() => {
      $answer.css('height', '0px');
    });

    $item.removeClass('active');
    $icon.attr('src', $icon.data('plus'));
  }

  function openItem($item) {
    const $answer = $item.find('.faq-answer');
    const $icon = $item.find('.faq-icon img');

    const height = $answer[0].scrollHeight;
    $answer.css('height', height + 'px');

    $item.addClass('active');
    $icon.attr('src', $icon.data('minus'));

    // set auto after open animation
    $answer.one('transitionend', function () {
      if ($item.hasClass('active')) {
        $answer.css('height', 'auto');
      }
    });
  }

  $items.each(function () {
    const $item = $(this);
    const $btn = $item.find('.faq-question');

    $btn.on('click', function () {

      // close other open items
      $items.not($item).each(function () {
        if ($(this).hasClass('active')) {
          closeItem($(this));
        }
      });

      // toggle current
      if ($item.hasClass('active')) {
        closeItem($item);
      } else {
        openItem($item);
      }
    });
  });
});


// --product single-faq


jQuery(function ($) {

  const $section = $('.how-to-use-section');
  const $items = $section.find('.htu-item');

  // Set initial height for active item
  $items.each(function () {
    const $item = $(this);
    const $answer = $item.find('.faq-answer-blk');

    if ($item.hasClass('active')) {
      $answer.css('height', $answer[0].scrollHeight + 'px');
    } else {
      $answer.css('height', 0);
    }
  });

  // Click handler
  $section.on('click', '.faq-question-blk', function () {
    const $item = $(this).closest('.htu-item');
    const $answer = $item.find('.faq-answer-blk');

    // If already open → close
    if ($item.hasClass('active')) {
      closeItem($item);
      return;
    }

    // Close all
    $items.each(function () {
      closeItem($(this));
    });

    // Open current
    openItem($item);
  });

  function openItem($item) {
    const $answer = $item.find('.faq-answer-blk');

    $item.addClass('active');
    $answer.css('height', $answer[0].scrollHeight + 'px');
  }

  function closeItem($item) {
    const $answer = $item.find('.faq-answer-blk');

    $item.removeClass('active');
    $answer.css('height', 0);
  }

});


// Leaf Membership Add
document.addEventListener('DOMContentLoaded', function () {

  const clubButtons = document.querySelectorAll(
    '.leaf-club-banner a, .club-membership .club-card a'
  );

  if (!clubButtons.length) return;

  clubButtons.forEach(btn => {
    const originalText = btn.textContent.trim();

    btn.addEventListener('click', function (e) {
      e.preventDefault();

      btn.textContent = 'ADDING…';
      btn.classList.add('is-loading');
      btn.style.pointerEvents = 'none';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: 46602277519526,
          quantity: 1,
          selling_plan: 2298413222
        })
      })
      .then(res => {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(() => fetch('/?sections=cart-drawer,cart-icon-bubble'))
      .then(res => res.json())
      .then(sections => {

        const drawer = document.querySelector('cart-drawer');
        if (!drawer) return;

        drawer.renderContents({
          sections: sections,
          cart: null
        });

        drawer.classList.remove('is-empty');
        drawer.querySelector('cart-drawer-items')?.classList.remove('is-empty');
        drawer.querySelector('#CartDrawer-Checkout')?.removeAttribute('disabled');

        window.initUpsellSwiper?.();

        drawer.open();
      })
      .catch(console.error)
      .finally(() => {
        btn.textContent = originalText;
        btn.classList.remove('is-loading');
        btn.style.pointerEvents = '';
      });
    });
  });

});


document.addEventListener('DOMContentLoaded', function() {
  // Select the quantity input container
  const quantityContainer = document.querySelector('.product-form__quantity');
  
  // Select the add to cart button container
  const addToCartButton = document.querySelector('.product-form-wr');

  if(quantityContainer && addToCartButton) {
    // Create a new wrapper div
    const wrapper = document.createElement('div');
    wrapper.className = 'quantity-add-wrapper'; // you can add your own class
    
    // Insert the wrapper before the quantity container
    quantityContainer.parentNode.insertBefore(wrapper, quantityContainer);

    // Move both elements into the new wrapper
    wrapper.appendChild(quantityContainer);
    wrapper.appendChild(addToCartButton);
  }
});



// (function () {
//   function formatMoney(cents) {
//     if (window.Shopify && Shopify.formatMoney) {
//       return Shopify.formatMoney(cents, window.shopifyMoneyFormat);
//     }
//     return '$' + (cents / 100).toFixed(2);
//   }

//   function updateATCFromSelectedVariant() {
//     const variantScript = document.querySelector(
//       'variant-selects script[type="application/json"][data-selected-variant]'
//     );
//     if (!variantScript) return;

//     let variant;
//     try {
//       variant = JSON.parse(variantScript.textContent);
//     } catch (e) {
//       return;
//     }

//     if (!variant || !variant.price) return;

//     const label = document.querySelector('.js-atc-label');
//     const btn = document.querySelector('.product-form__submit');
//     if (!label || !btn) return;

//     if (variant.available) {
//       label.textContent = `${formatMoney(variant.price)} | Add to Cart`;
//       btn.removeAttribute('disabled');
//     } else {
//       label.textContent = `${formatMoney(variant.price)} | Sold Out`;
//       btn.setAttribute('disabled', true);
//     }
//   }


//   document.addEventListener('DOMContentLoaded', updateATCFromSelectedVariant);

//   const observer = new MutationObserver(updateATCFromSelectedVariant);
//   observer.observe(document.body, {
//     subtree: true,
//     childList: true,
//     characterData: true
//   });
// })();


document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.banner-swiper', {
    loop: true,
    autoplay: {
      delay: 4000
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('.membership-toggle');
  const wrapper = document.querySelector('.membership-info');

  toggle.addEventListener('click', function () {
    wrapper.classList.toggle('active');
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', !expanded);
  });
});



// Instruction page htu image change
jQuery(function ($) {

  const $section = $('.how-to-use-section');

  $section.on('click', '.faq-question-blk', function () {
    const index = $(this).closest('.htu-item').data('index');

    // hide all media
    $section.find('.htu-media').removeClass('active').each(function () {
      if (this.tagName === 'VIDEO') {
        this.pause();
        this.currentTime = 0;
        this.load(); 
      }
    });

    // show active media
    const $activeMedia = $section.find('.htu-media[data-index="' + index + '"]');
    $activeMedia.addClass('active');

    // autoplay if video
    if ($activeMedia.is('video')) {
      const video = $activeMedia[0];
      video.currentTime = 0;
      video.load();
      video.play();
    }
  });

});